import {action, makeAutoObservable} from "mobx"

export enum HistorySyncState {
    SYNCED,
    IN_SYNC,
}

class HistorySyncStore {
    private state: HistorySyncState = HistorySyncState.SYNCED

    constructor() {
        makeAutoObservable(this)
    }

    getState(): HistorySyncState {
        return this.state
    }

    @action
    updateState(state: HistorySyncState) {
        this.state = state
    }
}

export const historySyncStore: HistorySyncStore = new HistorySyncStore()
